import SUB_DIVISION_NAMES from '../constants/lease_agreement/sub-division-names';

const getHasSubdivisionLA = (state) =>
  state && Object.keys(SUB_DIVISION_NAMES[state] || {}).length > 0;

export default getHasSubdivisionLA;
